import qs from 'qs';
import xhr from 'xhr';

// Strapi limita cada respuesta a 250 registros, incluso con limit=-1.
export default async function fetchAllSchoolActivityRecords(path, params) {
  const records = [];
  let start = 0;

  while (true) {
    const query = qs.stringify(
      {
        ...params,
        sort: params.sort || ['id:asc'],
        pagination: { start, limit: 250, withCount: true },
      },
      { encodeValuesOnly: true }
    );
    const response = await xhr(`${path}?${query}`);
    const body = response.data;
    const batch = body?.data ?? body;
    if (!Array.isArray(batch)) {
      throw new Error(`Respuesta inesperada al cargar ${path}`);
    }
    records.push(...batch);
    start += batch.length;

    const pagination = body?.meta?.pagination;
    if (batch.length === 0) break;
    if (typeof pagination?.total === 'number') {
      if (start >= pagination.total) break;
    } else if (batch.length < (pagination?.limit || 250)) {
      break;
    }
  }

  return records;
}
